import { render } from "./searchResultCount.vue?vue&type=template&id=3bcba401"
import script from "./searchResultCount.vue?vue&type=script&lang=js"
export * from "./searchResultCount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__